<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">


            <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
                <FormItem label="上传图片：" prop="icon">
                    <div class="j-img-echo">
                        <template v-if="!params.icon">
                            <Icon type="md-images" size="55" color="#c5c8ce"/>
                        </template>
                        <template v-else>
                            <img :src="params.icon">
                        </template>
                    </div>
                    <Upload :action="action" :headers="headers" :show-upload-list="false" name="file"
                            :on-success="uploadSuccess">
                        <Button icon="ios-cloud-upload-outline" style="width:488px">上传类别图标</Button>
                    </Upload>
                    <Alert show-icon closable style="margin-top:10px">建议上传140*140尺寸并且大小不能大于500kb的图片</Alert>
                </FormItem>
                <FormItem label="类别名称：" prop="name">
                    <Input v-model.trim="params.name" placeholder="请输入类别名称"></Input>
                </FormItem>
                <FormItem label="单价：" prop="priceMin">
                    <Input v-model.trim="params.priceMin" placeholder="请输入单价"></Input>
                </FormItem>
                <FormItem label="单位：" prop="categoryUnit">
                  <Select v-model="params.categoryUnit" placeholder="选择单位">
                    <Option value="1">公斤</Option>
                    <Option value="2">个</Option>
                  </Select>
                </FormItem>
                <FormItem label="排序：" prop="sort">
                    <Input v-model.trim="params.sort" placeholder="请输入类别排序"></Input>
                </FormItem>
            </Form>


            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            action: this.$uploadURL,
            headers: {
                token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
            },
            title: '查看信息',
            type: 0,
            params: {
                name: '',
                icon: '',
                priceMin: '',
                priceMax: '',
                sort: '999',
                categoryId: '',
                parentId: null,
                level: 1,
                categoryUnit: ''
            },
            ruleValidate: {
                name: [
                    {required: true, message: '类别名称不能为空', trigger: 'change'},
                ],
                icon: [
                    {required: true, message: '请上传类别图片', trigger: 'change'}
                ],
                priceMin: [
                    {required: true, message: '请输入普通单价', trigger: 'change'}
                ],
                sort: [
                    {required: true, message: '类别排序不能为空', trigger: 'change'}
                ],
                categoryUnit: [
                  {required: true, message: '单位不能为空', trigger: 'change'}
                ],
            }
        }
    },
    methods: {
        // 点击提交验证
        handleSubmit(name) {
            // console.log(this.params);
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // this.$Message.error('验证通过');
                    /**
                     * type判断
                     * 1.查看 2.新增 3.编辑
                     */
                    switch (this.type) {
                        case 1:
                            // this.title = '查看类别';
                            break;
                        case 2:
                            // 新增类别
                            this.addRecoveryCategory();
                            break;
                        case 3:
                            // 编辑类别
                            this.updateRecoveryCategory();
                            break;
                        default:
                            this.$Notice.error({
                                title: '类别管理',
                                desc: '查看，新增，编辑区分判断报错',
                                duration: 0
                            });
                            break
                    }
                } else {
                    this.$Message.error('还有信息没有填写合格哦~');
                }
            })
        },
        // 显示模态框
        show(type, row, level) {
            console.log(row)
            if (level == 1) {
                this.params.parentId = null;
            }
            if (level > 1 && type === 2) {
                this.params.parentId = row.categoryId;
            }
            if (level > 1 && type === 3) {
              this.params.parentId = row.parentId;
            }
            this.params.level = level;
            this.isShowModal = true;
            this.type = type;
            /**
             * type判断
             * 1.查看 2.新增 3.编辑
             */
            switch (type) {
                case 1:
                    this.title = '查看类别';
                    this.getInfo(row);
                    break;
                case 2:
                    this.title = '新增类别';
                    break;
                case 3:
                    this.title = '编辑类别';
                    this.getInfo(row);
                    break;
                default:
                    this.$Notice.error({
                        title: '类别管理',
                        desc: '查看，新增，编辑模态框报错',
                        duration: 0
                    });
                    break
            }
        },
        // 新增类别
        addRecoveryCategory() {
            this.$Spin.show();
            this.params.priceMax = this.params.priceMin
            this.axios.post('/recoveryCategory/addRecoveryCategory', this.params).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    this.$emit('changeDate');
                    this.$Message.success('操作成功.');
                    this.hide('formValidate');
                }
                if (res.status == 201) {
                    this.$Message.error(res.msg);
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '新增类别接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 编辑类别
        updateRecoveryCategory() {
            this.$Spin.show();
            this.axios.post('/recoveryCategory/updateRecoveryCategory', this.params).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    this.$emit('changeDate');
                    this.$Message.success('操作成功.');
                    this.hide('formValidate');
                }
                if (res.status == 201) {
                    this.$Message.error(res.msg);
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '编辑类别接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 查询类别详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryCategory/getInfo', {
                categoryId: row.categoryId
            }).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    this.params.name = res.data.name;
                    this.params.icon = res.data.icon;
                    this.params.priceMin = res.data.priceMin ? res.data.priceMin.toString() : '';
                    this.params.priceMax = res.data.priceMax ? res.data.priceMax.toString() : '';
                    this.params.sort = res.data.sort ? res.data.sort.toString() : '999';
                    this.params.categoryUnit = res.data.categoryUnit ? res.data.categoryUnit.toString() : '';
                    this.params.categoryId = res.data.categoryId;
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看类别详情接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 上传成功
        uploadSuccess(response, file, fileList) {
            if (response.status == 200) {
                this.params.icon = response.data;
            }
            if (response.status == 201) {
                this.$Message.error(response.msg);
            }
            if (response.status == 500) {
                this.$Notice.error({
                    title: '服务器内部错误',
                    desc: '上传类别接口报错',
                    duration: 0
                });
            }
        },
        // 关闭模态框
        hide(name) {
            this.isShowModal = false;
            this.params.categoryId = '';
            this.params.parentId = null;
            this.params.level = 1;
            this.$refs[name].resetFields();
        }
    }
}
</script>

<style scoped>

</style>